import React from "react";
import { MenuItem, Select, MenuProps } from "@mui/material";
import { useTranslation } from "react-i18next";

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const menuProps: Partial<MenuProps> = {
    PaperProps: {
      sx: {
        marginTop: "4px",
        borderRadius: "8px",
        border: "1px solid rgba(0, 0, 0, 0.1)",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.05)",
        "& .MuiMenuItem-root": {
          fontSize: "0.875rem",
          padding: "4px 12px",
          minHeight: "auto",
        },
      },
    },
  };

  return (
    <Select
      value={i18n.language}
      onChange={(e) => i18n.changeLanguage(e.target.value)}
      size="small"
      variant="standard"
      disableUnderline
      MenuProps={menuProps}
      sx={{ 
        ml: 0, 
        color: "#000000",
        backgroundColor: "transparent",
        border: "none",
        fontSize: "0.875rem",
        "& .MuiSelect-select": {
          color: "#000000",
          padding: "4px 20px 4px 8px",
          backgroundColor: "transparent",
          fontSize: "0.875rem",
          minHeight: "auto",
        },
        "& .MuiSelect-icon": {
          color: "#000000",
          fontSize: "1rem",
        },
        "& .MuiOutlinedInput-notchedOutline": {
          border: "none",
        },
        "&:before": {
          display: "none",
        },
        "&:after": {
          display: "none",
        },
        "&:hover": {
          backgroundColor: "#eeeeee",
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
        },
        "&.Mui-focused": {
          backgroundColor: "#eeeeee",
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
        },
      }}
    >
      <MenuItem value="de" sx={{ fontSize: "0.875rem", padding: "4px 12px", minHeight: "auto" }}>DE</MenuItem>
      <MenuItem value="en" sx={{ fontSize: "0.875rem", padding: "4px 12px", minHeight: "auto" }}>EN</MenuItem>
    </Select>
  );
};

export default LanguageSwitcher;
